import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'src/store';
import { Status } from 'src/ts/enums/status';
import { NAME } from './constants';
import {
  getApplicantReportPDFReducer,
  getEntryReportByIdReducer,
  getReportsByEntryIdReducer,
  initialState,
  StateData
} from './reducers';

const fdeReportSlice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    resetEntryReport: (state: StateData) => {
      state.getEntryReportById = initialState.getEntryReportById;
    },
    resetGetApplicantReportPDF: (state: StateData) => {
      state.getApplicantReportPDF = initialState.getApplicantReportPDF;
    },
    resetGetReportsByEntryId: (state: StateData) => {
      state.getReportsByEntryId = initialState.getReportsByEntryId;
    }
  },
  extraReducers: (builder) => {
    getEntryReportByIdReducer(builder);
    getApplicantReportPDFReducer(builder);
    getReportsByEntryIdReducer(builder);
  }
});

export const selectors = {
  getEntryReport: {
    isLoading: (state: RootState) => state[NAME].getEntryReportById.status === Status.LOADING,
    isIdle: (state: RootState) => state[NAME].getEntryReportById.status === Status.IDLE,
    error: (state: RootState) => state[NAME].getEntryReportById.error,
    data: (state: RootState) => state[NAME].getEntryReportById.data
  },
  getDownloadApplicantReport: {
    isLoading: (state: RootState) => state[NAME].getApplicantReportPDF.status === Status.LOADING,
    error: (state: RootState) => state[NAME].getApplicantReportPDF.error || null,
    file: (state: RootState) => state[NAME].getApplicantReportPDF.data,
    fileName: (state: RootState) => state[NAME].getApplicantReportPDF.fileName || '',
    preset: (state: RootState) => state[NAME].getApplicantReportPDF.preset || ''
  },
  getReportsByEntryId: {
    isLoading: (state: RootState) => state[NAME].getReportsByEntryId.status === Status.LOADING,
    isIdle: (state: RootState) => state[NAME].getReportsByEntryId.status === Status.IDLE,
    error: (state: RootState) => state[NAME].getReportsByEntryId.error,
    data: (state: RootState) => state[NAME].getReportsByEntryId.data
  }
};

export const { reducer, actions } = fdeReportSlice;
